<script setup>
import { computed } from 'vue';
const props = defineProps({
    locked: {
        type: Boolean,
        default: false
    },
    fit : {
        type: Boolean,
        default: false
    },
    condition: {
        default: true
    },
    blur: {
        type: Boolean,
        default: false
    }
});

import ProBadge from './ProBadge.vue';

const locked = computed( () => {
    return props.locked && ! formychat_admin_vars.is_premium ? 'formychat-locked child:pointer-events-none opacity-60' : null
})

</script>

<template>
    <transition name="no">
        <div class="relative w-full" v-if="!!props.condition" :class="{ 'opacity-50 pointer-events-none' : props.blur }">
            <div v-bind="$attrs" class="flex flex-col gap-2" :class="{ 'opacity-60 pointer-events-none w-fit' : locked, 'w-fit' : fit }">
                <slot />
            </div>
            <div class="absolute right-0 top-0" v-if="locked">
                <ProBadge />
            </div>
        </div>
    </transition>
</template>

<style scoped>
    .pro-badge {
        position: absolute !important;
        top: 0 !important;
        right: 0 !important;
    }
</style>